/* eslint-disable import/no-anonymous-default-export */
import environment from '../environments/Environment';
import HttpService from './HttpService';

export default {
    getDataBreachList() {
        return HttpService.get(environment.API_DATA_BREACH + '/form');
    },
    getDataBreachFormById(id) {
        return HttpService.get(environment.API_DATA_BREACH + '/form/' + id);
    },
    getDataBreachFormPublichById(id) {
        return HttpService.get(
            environment.API_DATA_BREACH_PUBLIC + '/publish-version/' + id
        );
    },
    updateDataBreachForm(payload) {
        return HttpService.put(environment.API_DATA_BREACH + '/form', payload);
    },
    getMasterDataBreachTemplate() {
        return HttpService.get(environment.API_DATA_BREACH + '/m/form');
    },
    getResponsibilityList(params) {
        return HttpService.get(
            environment.API_DATA_BREACH_RESPONSIBILITY + '/list',
            {
                params,
            }
        );
    },
    getDataBreachLogList(params) {
        return HttpService.get(environment.API_DATA_BREACH + '/log', {
            params,
        });
    },
    getStatusDataBreachList() {
        return HttpService.get(
            environment.API_DATA_BREACH + '/log/m/status/t_data_breach'
        );
    },
    getStatusActionList() {
        return HttpService.get(
            environment.API_DATA_BREACH + '/log/m/status/action_plan'
        );
    },
    getResponsibilityDetail(id) {
        return HttpService.get(
            environment.API_DATA_BREACH_RESPONSIBILITY + '/' + id
        );
    },
    getDataBreachLogDetail(id) {
        return HttpService.get(environment.API_DATA_BREACH + '/log/' + id);
    },
    getUserList() {
        return HttpService.get(environment.API_USER_LIST);
    },
    saveResponsibility(payload) {
        return HttpService.post(
            environment.API_DATA_BREACH_RESPONSIBILITY,
            payload
        );
    },
    updateResponsibility(payload) {
        return HttpService.put(
            environment.API_DATA_BREACH_RESPONSIBILITY,
            payload
        );
    },
    deleteDataBreachForm(id) {
        return HttpService.delete(environment.API_DATA_BREACH + '/form/' + id);
    },
    getHistoryDataBreach(params) {
        return HttpService.get(environment.API_DATA_BREACH + '/form/history', {
            params,
        });
    },
    submitDataBreachForm(payload) {
        return HttpService.post(
            environment.API_DATA_BREACH_PUBLIC + '/form/submit',
            payload
        );
    },
    // Dashboard service
    getCircleChart(dataBreachGroupId) {
        return HttpService.get(
            environment.API_DATA_BREACH +
                '/summary/circle-chart/' +
                dataBreachGroupId
        );
    },
    getSummaryDetail() {
        return HttpService.get(environment.API_DATA_BREACH + '/summary/detail');
    },
    getGroupList() {
        return HttpService.get(environment.API_DATA_BREACH + '/group-list');
    },
    renameDataBreachName(payload) {
        return HttpService.post(
            environment.API_DATA_BREACH + '/log/rename',
            payload
        );
    },
    getUserPermission(id) {
        return HttpService.get(
            environment.API_DATA_BREACH_RESPONSIBILITY + '/user/' + id
        );
    },
    startDataBreach(payload) {
        return HttpService.put(
            environment.API_DATA_BREACH + '/log/change-status',
            payload
        );
    },
    createActionPlan(payload) {
        return HttpService.post(
            environment.API_DATA_BREACH + '/log/action-plan',
            payload
        );
    },
    updateActionPlan(payload) {
        return HttpService.put(
            environment.API_DATA_BREACH + '/log/action-plan',
            payload
        );
    },
    getActionPlanList(params) {
        return HttpService.get(
            environment.API_DATA_BREACH + '/log/action-plan',
            {
                params,
            }
        );
    },
    getActionPlanDetail(id) {
        return HttpService.get(
            environment.API_DATA_BREACH + '/log/action-plan/' + id
        );
    },
    deleteActionPlan(id) {
        return HttpService.delete(
            environment.API_DATA_BREACH + '/log/action-plan/' + id
        );
    },
    getInformingDetail(id) {
        return HttpService.get(
            environment.API_DATA_BREACH + '/log/informing/' + id
        );
    },
    updateInforming(payload) {
        return HttpService.put(
            environment.API_DATA_BREACH + '/log/informing',
            payload
        );
    },
    saveInforming(payload) {
        return HttpService.post(
            environment.API_DATA_BREACH + '/log/informing',
            payload
        );
    },
    getDocumentList(params) {
        return HttpService.get(environment.API_DATA_BREACH + `/log/document`, {
            params,
        });
    },
    renameDataBreachDescription(payload) {
        return HttpService.put(
            environment.API_DATA_BREACH + '/log/document',
            payload
        );
    },
    deleteDocument(id) {
        return HttpService.delete(
            environment.API_DATA_BREACH + '/log/document/' + id
        );
    },
    uploadDocument(payload) {
        return HttpService.post(
            environment.API_DATA_BREACH + '/log/document',
            payload
        );
    },
    getSelfAssessment(id) {
        return HttpService.get(
            environment.API_DATA_BREACH + '/log/self-assessment/' + id
        );
    },
    createSelfAssessment(payload) {
        return HttpService.post(
            environment.API_DATA_BREACH + '/log/self-assessment',
            payload
        );
    },
    updateSelfAssessment(payload) {
        return HttpService.put(
            environment.API_DATA_BREACH + '/log/self-assessment',
            payload
        );
    },
    getConsequenceDetail(id) {
        return HttpService.get(
            environment.API_DATA_BREACH + '/log/consequences/' + id
        );
    },
    updateConsequence(payload) {
        return HttpService.put(
            environment.API_DATA_BREACH + '/log/consequences',
            payload
        );
    },
    saveConsequence(payload) {
        return HttpService.post(
            environment.API_DATA_BREACH + '/log/consequences',
            payload
        );
    },
    manualSubmit(payload) {
        return HttpService.post(
            environment.API_DATA_BREACH + '/manual/submit',
            payload
        );
    },
    getDocument(id) {
        return HttpService.get(
            environment.API_DATA_BREACH + '/log/document/' + id
        );
    },
    manualUpdate(payload) {
        return HttpService.put(
            environment.API_DATA_BREACH + '/manual',
            payload
        );
    },
    export(type) {
        return HttpService.get(
            environment.API_DATA_BREACH + '/export/log',
            {
                params: { ...type },
                responseType: 'blob',
            }
        );
    },
};
